/**
 * Velix version — single source of truth.
 * Update this file only when releasing a new version.
 */
export const VERSION = '5.3.0';
